// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.packageContainer {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.6rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  border: 0.0625rem solid var(--Foreground);
  page-break-inside: avoid;
  break-inside: avoid;
}
.packageContainer.active {
  border: 0.0625rem solid var(--Pending);
  background-color: var(--Hover);
}
.packageContainer:hover {
  background-color: var(--Hover);
}
.packageContainer .pricingDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}
.packageContainer .pricingDiv .packageName {
  color: var(--AccentColor);
  font-size: 1rem;
  font-weight: 700;
}
.packageContainer .pricingDiv .princing {
  text-wrap: nowrap;
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--TextColor);
}
.packageContainer .pricingDiv p {
  color: var(--TextColor);
  font-size: 0.8rem;
}
.packageContainer .pricingDiv p:last-child {
  opacity: 0.7;
}
.packageContainer .checksList {
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}
.packageContainer .checksList .Checks {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.packageContainer .checksList .Checks input[type=checkbox] {
  min-height: 0.875rem;
  min-width: 0.875rem;
  appearance: none;
  border: 1px solid var(--AccentColor);
  border-radius: 0.15rem;
}
.packageContainer .checksList .Checks input[type=checkbox]:checked {
  min-height: 0.875rem;
  min-width: 0.875rem;
  appearance: none;
  background-color: var(--AccentColor);
  border-radius: 0.15rem;
}
.packageContainer .checksList .Checks input[type=checkbox]:checked::before {
  content: "✔";
  display: block;
  text-align: center;
  color: white;
  font-size: 0.6rem;
}
.packageContainer .checksList .Checks span {
  font-size: 0.75rem;
  color: var(--TextColor);
  cursor: pointer;
}
.packageContainer .checksList .Checks svg {
  min-height: 0.875rem;
  min-width: 0.875rem;
}
.packageContainer .checksList div {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.6rem;
}
.packageContainer .checksList div p {
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--TextColor);
  font-size: 0.9rem;
}
.packageContainer .checksList div input[type=checkbox] {
  width: 0.8rem;
  height: 0.8rem;
  min-width: 0.8rem;
  min-height: 0.8rem;
  background-color: transparent;
  border: 0.0625rem solid var(--AccentColor);
  border-radius: 4px;
  appearance: none;
  cursor: pointer;
  outline: none;
}
.packageContainer .checksList div input[type=checkbox]:checked {
  background-color: var(--AccentColor);
}
.packageContainer .checksList div input[type=checkbox]:checked::before {
  content: "✔";
  display: block;
  text-align: center;
  color: white;
  font-size: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/BeginVerification/Package/Package.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EAEA,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,wBAAA;EAAA,mBAAA;AACF;AAAE;EACE,sCAAA;EACA,8BAAA;AAEJ;AAAE;EACE,8BAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACJ;AAAI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAEN;AAAI;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAEN;AAAI;EACE,uBAAA;EACA,iBAAA;AAEN;AADM;EACE,YAAA;AAGR;AACE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACJ;AAAI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAEN;AADM;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;AAGR;AADM;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;AAGR;AAFQ;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAIV;AADM;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;AAGR;AADM;EACE,oBAAA;EACA,mBAAA;AAGR;AAAI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAEN;AADM;EACE,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;AAGR;AADM;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AAGR;AADM;EACE,oCAAA;AAGR;AACM;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AACR","sourcesContent":[".packageContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  padding: 0.6rem;\n  // background-color: var(--Foreground);\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  border: 0.0625rem solid var(--Foreground);\n  break-inside: avoid;\n  &.active {\n    border: 0.0625rem solid var(--Pending);\n    background-color: var(--Hover);\n  }\n  &:hover {\n    background-color: var(--Hover);\n  }\n\n  .pricingDiv {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.6rem;\n    .packageName {\n      color: var(--AccentColor);\n      font-size: 1rem;\n      font-weight: 700;\n    }\n    .princing {\n      text-wrap: nowrap;\n      font-size: 1.8rem;\n      font-weight: 800;\n      color: var(--TextColor);\n    }\n    p {\n      color: var(--TextColor);\n      font-size: 0.8rem;\n      &:last-child {\n        opacity: 0.7;\n      }\n    }\n  }\n  .checksList {\n    padding-left: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.9rem;\n    .Checks {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.5rem;\n      input[type=\"checkbox\"] {\n        min-height: 0.875rem;\n        min-width: 0.875rem;\n        appearance: none;\n        border: 1px solid var(--AccentColor);\n        border-radius: 0.15rem;\n      }\n      input[type=\"checkbox\"]:checked {\n        min-height: 0.875rem;\n        min-width: 0.875rem;\n        appearance: none;\n        background-color: var(--AccentColor);\n        border-radius: 0.15rem;\n        &::before {\n          content: \"✔\";\n          display: block;\n          text-align: center;\n          color: white;\n          font-size: 0.6rem;\n        }\n      }\n      span {\n        font-size: 0.75rem;\n        color: var(--TextColor);\n        cursor: pointer;\n      }\n      svg {\n        min-height: 0.875rem;\n        min-width: 0.875rem;\n      }\n    }\n    div {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.6rem;\n      p {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        color: var(--TextColor);\n        font-size: 0.9rem;\n      }\n      input[type=\"checkbox\"] {\n        width: 0.8rem;\n        height: 0.8rem;\n        min-width: 0.8rem;\n        min-height: 0.8rem;\n        background-color: transparent;\n        border: 0.0625rem solid var(--AccentColor);\n        border-radius: 4px;\n        appearance: none;\n        cursor: pointer;\n        outline: none;\n      }\n      input[type=\"checkbox\"]:checked {\n        background-color: var(--AccentColor);\n        // border-color: 1px solid var(--AccentColor);\n        // border-radius: 50%;\n      }\n      input[type=\"checkbox\"]:checked::before {\n        content: \"✔\";\n        display: block;\n        text-align: center;\n        color: white;\n        font-size: 0.5rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
